export enum RememberMode {
    Visible = 0, // default
    Enabled = 1,
    Hidden = 2,
    HiddenEnabled = 3,
}
